import { lazy } from 'react';

export const ReviewDocumentForm = lazy(() => import('./ReviewDocumentForm'));
